import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useDispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import useAuth from "hooks/useAuth";
import io from "socket.io-client";

const SessionAlert = () => {
  const [open, setOpen] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const dispatch = useDispatch();
  const { logout, user } = useAuth();

  useEffect(() => {
    if (!user?.id) return;

    const socket = io("https://api.moofunk169.com");

    // Join admin room instead of user room
    socket.emit("join-admin-room", user.id);

    // Listen for force logout events
    socket.on("force-logout", (data) => {
      console.log("Admin force logout received:", data);
      setAlertMessage(data.message);
      setOpen(true);
    });

    return () => {
      socket.disconnect();
    };
  }, [user]);

  const handleForceLogout = () => {
    setOpen(false);

    // Show notification
    dispatch(
      openSnackbar({
        open: true,
        message:
          "คุณถูกออกจากระบบเนื่องจากมีการเข้าสู่ระบบจากอุปกรณ์อื่น (แอดมิน)",
        variant: "alert",
        alert: {
          color: "warning",
        },
        close: true,
      })
    );

    // Force logout
    logout();
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      aria-labelledby="session-alert-title"
      aria-describedby="session-alert-description"
    >
      <DialogTitle
        id="session-alert-title"
        sx={{ textAlign: "center", color: "warning.main" }}
      >
        แจ้งเตือนการเข้าสู่ระบบ
      </DialogTitle>
      <DialogContent>
        <Typography
          id="session-alert-description"
          sx={{ textAlign: "center", mb: 2 }}
        >
          {alertMessage}
        </Typography>
        <Typography
          variant="body2"
          sx={{ textAlign: "center", color: "text.secondary" }}
        >
          คุณจะถูกออกจากระบบอัตโนมัติ
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          onClick={handleForceLogout}
          color="warning"
          variant="contained"
          fullWidth
        >
          ตกลง
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionAlert;
